import script from "./DualPane.vue?vue&type=script&lang=ts&setup=true"
export * from "./DualPane.vue?vue&type=script&lang=ts&setup=true"

import "./DualPane.vue?vue&type=style&index=0&id=4a3fb291&lang=scss"

const __exports__ = script;

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSlideTransition from 'quasar/src/components/slide-transition/QSlideTransition.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QIcon,QSlideTransition});
